import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";

export async function getCajaAperturaDetail(aperturaId: string, movimientoId: string): Promise<CajaMovimiento> {
    await sleep(1000);
    const response = await api.get("cajas/aperturas/" + aperturaId + "/details/" + movimientoId);
    return response.data;
}

export function useGetCajaAperturaDetailQuery(aperturaId: string, movimientoId: string, queryConfig: QueryConfig<CajaMovimiento> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCajaAperturaDetail(aperturaId, movimientoId),
        queryKey: ["cajas", "aperturas", aperturaId, "details", movimientoId],
    })
}

export interface GetCajaAperturaDetailQueryProps {
    aperturaId: string,
    movimientoId: string,
    queryConfig?: QueryConfig<CajaMovimiento>,
    children?: (queryResult: QueryResult<CajaMovimiento>) => ReactNode
}

export function GetCajaAperturaDetailQuery({
    aperturaId,
    movimientoId,
    children,
    queryConfig
}: GetCajaAperturaDetailQueryProps) {
    const queryResult = useGetCajaAperturaDetailQuery(aperturaId, movimientoId, queryConfig);
    return children && children(queryResult);
}